import { createSlice } from '@reduxjs/toolkit';

const initialState={
    currapikey:null
}
export const currentApikeySelectedSlice = createSlice({
  name: ' currapikey',
  initialState,
  reducers: {

    setCurrentApikey: (state, action) => {
      state.currapikey= action.payload;
    },
    setLogoutCurrentApikey: (state,action)=>{
      state.currapikey=null
    }
  },
});

export const {  setCurrentApikey,setLogoutCurrentApikey } = currentApikeySelectedSlice.actions;

export default currentApikeySelectedSlice.reducer;
